import { Link } from "react-router-dom";
import About from "@/components/sections/About";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import Stats from "@/components/sections/Stats";
import HiringProcess from "@/components/sections/HiringProcess";
import Breadcrumb from "@/components/Breadcrumb";

export default function AboutPage() {
  return (
    <>
      <PageHero
        eyebrow="About Us"
        title="Building India's most trusted HR partner"
        subtitle="A professional team committed to delivering compliant, scalable and quality-first workforce solutions to enterprises, SMEs and startups."
      />
      <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "About" }]} />
      <About />
      <Stats />
      <HiringProcess />
      <WhyChooseUs />
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl text-slate-900">Ready to transform your workforce?</h2>
          <p className="mt-4 text-slate-600">Talk to our HR experts today for a tailored proposal.</p>
          <Link
            to="/contact"
            data-testid="about-final-cta"
            className="mt-8 inline-flex px-7 py-3.5 rounded-lg bg-primary text-white font-semibold hover:bg-primary-hover transition-colors"
          >
            Request Proposal
          </Link>
        </div>
      </section>
    </>
  );
}

function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section className="pt-32 pb-16 lg:pt-40 lg:pb-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-primary">{eyebrow}</p>
        <h1 className="mt-3 font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl text-slate-900 leading-[1.05] tracking-tight max-w-4xl mx-auto">
          {title}
        </h1>
        <p className="mt-6 max-w-2xl mx-auto text-base sm:text-lg text-slate-600 leading-relaxed">{subtitle}</p>
      </div>
    </section>
  );
}
